export const services = [
    {
        image: "1",
        alt: "Tax",
        title: "South Asia Business Analysis",
        description: "Our team leverages advanced data analysis tools and local networks to assess the South Asian business environment. We provide services including market entry strategies, industry trends, competitive analysis, regulatory compliance, and risk management. WIT Consulting delivers tailored solutions to ensure informed business decisions based on reliable data and market insights.",
    },
    {
        image: "2",
        alt: "South Asia Investment Risk Assessment",
        title: "South Asia Investment Risk Assessment",
        description: "We have a specialized team to assess investment risks, covering political risks, economic fluctuations, legal changes, and more. We provide both risk identification and mitigation strategies, along with investment recommendations, to protect clients' assets and maximize returns.",
    },
    {
        image: "3",
        alt: "In-Depth Regional Policy Research",
        title: "In-Depth Regional Policy Research",
        description: "We analyze the impact of international and regional policies on the South Asian economy and business environment, focusing on economic cooperation organizations like SAARC. Through forward-looking policy insights, we help clients navigate opportunities and challenges arising from policy changes, ensuring their business strategies align with regional developments.",
    },
    {
        image: "4",
        alt: "South Asia Geopolitical Analysis",
        title: "South Asia Geopolitical Analysis",
        description: "We analyze the political and economic interactions between South Asian countries, including border disputes, economic agreements, and geopolitical impacts. WIT Consulting helps clients understand regional and external political dynamics, providing solid analytical support for their strategic decisions."
    }
];
